import React from 'react'

const DeviceForm = ({ navigator, editDevice, handleAddDevice, handleEditDevice, updateDeviceState, deleteDevice, responseMessage }) => {

    const getFormConfirmationAlert = (responseMessage = {}) => {
        if (responseMessage.error) {
            return <div className="alert alert-danger col-sm-4 text-center small-margin-top">{responseMessage.error}</div>
        }

        if (responseMessage.success) {
            return <h4 className="alert alert-success col-sm-4 text-center small-margin-top"> {responseMessage.success} </h4>
        }

        if (responseMessage.serverError) {
            return <div className="alert alert-danger col-sm-4 text-center small-margin-top">{responseMessage.serverError}</div>
        }
    }

    
    const getRegisteredApp = (deviceDetails) => {
        let tokenStatus = "";
        if (typeof deviceDetails.batteryToken !== "undefined") {
          tokenStatus = tokenStatus + "Battery";
        }
    
        if (typeof deviceDetails.hostToken !== "undefined") {
          if (tokenStatus === "") {
            tokenStatus = tokenStatus + "Host";
          } else {
            tokenStatus = tokenStatus + " ; Host";
          }
        }
    
        return tokenStatus;
    }

    const renderHeading = () => {
        if ( typeof editDevice.deviceId === "undefined" || editDevice.deviceId === "" ) return <h3>Add New Device</h3>;
        if (editDevice.isNewDevice) return <h3>Register Device</h3>;
        return <h3>Edit Device</h3>;
    }

    const renderSaveButton = () => {
        if ( typeof editDevice.deviceId === "undefined" || editDevice.deviceId === "" ) {
            return (
                <button type="button" className="btn btn-primary mainDivSubmit add-device-save" onClick={() => handleAddDevice()}>
                    Create
                </button>
            )
        }

        if (editDevice.isNewDevice) {
            return (
                <button type="button" className="btn btn-primary mainDivSubmit register-device-save" onClick={handleEditDevice}>
                    Register
                </button>
            )
        }

        return (
            <button type="button" className="btn btn-primary mainDivSubmit edit-device-save" onClick={handleEditDevice}>
                Update
            </button>
        )
    }

    return (
        <div>
            <ol className="breadcrumb">
                <li>
                    <a onClick={ navigator.requestDeviceManagement }>
                        Device Management
                    </a>
                </li>
                <li className="active">
                    { editDevice.deviceId ? "Edit Device" : "Add New Device" }
                </li>
            </ol>
            <div className="edit-device-main-div pull-left">
                <div className="edit-device-form">
                    <form>
                        <div className="flex-center">{ getFormConfirmationAlert(responseMessage) }</div>
                        <div className="edit-device-form-heading">
                            {renderHeading()}
                        </div>
                        <div className="pull-left col-xs-12">
                            <div className="form-group col-xs-12 col-sm-6">
                            <label htmlFor="name" className="pull-left"
                                style={{ color: editDevice.errorField == "name" ? "red" : "#429bd5" }}
                            >
                                Device name *
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                placeholder="Device name"
                                value={editDevice.name}
                                name="name"
                                onChange={updateDeviceState}
                            />
                            { editDevice.errorField == "name" ? errorMessage : "" }
                            </div>
                            <div className="form-group col-xs-12 col-sm-6">
                            <label
                                htmlFor="mobileNumber"
                                className="pull-left"
                                style={{ color: editDevice.errorField == "mobileNumber" ? "red" : "#429bd5"}}
                            >
                                Mobile number *
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="mobileNumber"
                                placeholder="Mobile number"
                                value={editDevice.mobileNumber}
                                name="mobileNumber"
                                onChange={updateDeviceState}
                            />
                            { editDevice.errorField == "mobileNumber" ? errorMessage : "" }
                            </div>
                        </div>

                        <div className="pull-left col-xs-12">
                            <div className="form-group col-xs-12 col-sm-6">
                            <label
                                htmlFor="serialNumber"
                                className="pull-left"
                                style={{ color: editDevice.errorField == "serialNumber" ? "red" : "#429bd5" }}
                            >
                                Serial number *
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="serialNumber"
                                placeholder="Serial number"
                                value={editDevice.serialNumber}
                                name="serialNumber"
                                onChange={updateDeviceState}
                            />
                            {editDevice.errorField == "serialNumber" ? errorMessage : ""}
                            </div>
                            <div className="form-group col-xs-12 col-sm-6">
                            <label
                                htmlFor="imei"
                                className="pull-left"
                                style={{ color: editDevice.errorField == "imei" ? "red" : "#429bd5" }}
                            >
                                IMEI *
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="imei"
                                placeholder="IMEI"
                                value={editDevice.imei}
                                name="imei"
                                onChange={updateDeviceState}
                            />
                            { editDevice.errorField == "imei" ? errorMessage : "" }
                            </div>
                        </div>

                        <div className="pull-left col-xs-12">
                            <div className="form-group col-xs-12 col-sm-6">
                            <label
                                className="questionLabel"
                                style={{ color: editDevice.errorField == "os" ? "red" : "#429bd5" }}
                            >
                                OS *
                            </label>
                            <select
                                className="form-control"
                                id="selectOS"
                                value={editDevice.os}
                                name="os"
                                onChange={updateDeviceState}
                            >
                                <option>Select OS</option>
                                <option>Android</option>
                                <option>iOS</option>
                            </select>
                            { editDevice.errorField == "os" ? errorMessage : "" }
                            </div>
                            <div className="form-group col-xs-12 col-sm-6">
                            <label
                                htmlFor="osVersion"
                                className="pull-left"
                                style={{ color: editDevice.errorField == "osVersion" ? "red" : "#429bd5" }}
                            >
                                OS version *
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="osVersion"
                                placeholder="OS Version"
                                value={editDevice.osVersion}
                                name="osVersion"
                                onChange={updateDeviceState}
                            />
                            { editDevice.errorField == "osVersion" ? errorMessage : "" }
                            </div>
                        </div>

                        <div className="pull-left col-xs-12">
                            <div className="form-group col-xs-12 col-sm-6">
                            <label
                                htmlFor="deviceModel"
                                className="pull-left"
                                style={{ color: editDevice.errorField == "model" ? "red" : "#429bd5" }}
                            >
                                Device model *
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="deviceModel"
                                placeholder="Device model"
                                value={editDevice.model}
                                name="model"
                                onChange={updateDeviceState}
                            />
                            { editDevice.errorField == "model" ? errorMessage : "" }
                            </div>
                            <div className="form-group col-xs-12 col-sm-6">
                            <label
                                className="testDeviceType"
                                style={{ color: editDevice.errorField == "deviceType" ? "red" : "#429bd5" }}
                            >
                                Test device type *
                            </label>
                            <select
                                className="form-control"
                                id="testDeviceType"
                                value={editDevice.deviceType}
                                name="deviceType"
                                onChange={updateDeviceState}
                            >
                                <option>Select Test device type</option>
                                <option>Battery</option>
                                <option>Functional</option>
                                <option>Ad-hoc</option>
                            </select>
                            {editDevice.errorField == "deviceType" ? errorMessage : ""}
                            </div>
                        </div>

                        <div className="pull-left col-xs-12">
                            <div className="form-group col-xs-12 col-sm-6">
                            <label htmlFor="udid" className="pull-left">
                                UDID
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="udid"
                                placeholder="UDID"
                                value={editDevice.udid}
                                name="udid"
                                onChange={updateDeviceState}
                            />
                            </div>
                            <div className="form-group col-xs-12 col-sm-6">
                            <label htmlFor="identifier" className="pull-left">
                                Identifier
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="identifier"
                                placeholder="Identifier"
                                value={editDevice.identifier}
                                name="identifier"
                                onChange={updateDeviceState}
                            />
                            </div>
                        </div>

                        <div className="pull-left col-xs-12">
                            <div className="form-group col-xs-12 col-sm-6">
                            <label>Tracking device *</label>
                            <input
                                id="cmn-toggle-1"
                                className="cmn-toggle cmn-toggle-round"
                                type="checkbox"
                                name="trackingDevice"
                                checked={editDevice.trackingDevice}
                                onChange={updateDeviceState}
                            />
                            <label htmlFor="cmn-toggle-1" />
                            </div>

                            <div className="form-group col-xs-12 col-sm-6">
                            <label htmlFor="identifier" className="pull-left">
                                App Registered
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="registeredApp"
                                placeholder="registeredApp"
                                value={getRegisteredApp(editDevice)}
                                name="registeredApp"
                                readOnly
                            />
                            </div>
                        </div>

                        <div className="col-xs-12">
                            { editDevice.deviceId && (
                                  <a href="#" className="pull-left delete-device" onClick={() => deleteDevice(editDevice.deviceId)}>
                                    Delete Device
                                </a>
                            )}
                            {renderSaveButton()}
                        </div>
                    </form>
                </div>
            </div>
        </div>
        )
    
}

export default DeviceForm